const metersToMiles = (m) => (m ?? 0) / 1609.34;

export function buildCoveragePayload({ markers = [], ignoreAreas = [], units = 'miles' } = {}) {
  const toRadius = (meters) =>
    units === 'miles' ? metersToMiles(Number(meters || 0)) : Number(meters || 0);

  const sortedMarkers = [...markers].sort((a, b) => {                  
    const ai = Number.isFinite(a.index) ? a.index : Infinity;
    const bi = Number.isFinite(b.index) ? b.index : Infinity;
    if (ai !== bi) return ai - bi;
    return (a.name || '').localeCompare(b.name || '');
  });

  return sortedMarkers.map((c) => {
    const children = ignoreAreas
      .filter((ig) => ig.parentId === c.id)
      .sort((a, b) => {
        const ai = Number.isFinite(a.index) ? a.index : Infinity;
        const bi = Number.isFinite(b.index) ? b.index : Infinity;
        if (ai !== bi) return ai - bi;
        return (a.name || '').localeCompare(b.name || '');
      })
      .map((ig) => ({
        id: ig.id,
        name: ig.name,
        lat: Number(ig.lat),
        lng: Number(ig.lng),
        radius: toRadius(ig.radius), // en miles o meters según `units`
        address: ig.address || '',
        city: ig.city || '',
        state: ig.state || '',
        country: ig.country || '',
      }));

    return {
      id: c.id,
      name: c.name,                 // <- nombre del coverage
      lat: Number(c.lat),
      lng: Number(c.lng),
      radius: toRadius(c.radius),   // en miles o meters según `units`
      address: c.address || '',
      city: c.city || '',
      state: c.state || '',
      country: c.country || '',
      ignoreAreas: children,
    };
  });
}
